import { RECAPCHA_SCRIPT, RECAPCHA_SITE_KEY } from '@/constants/configurations';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';

const SCRIPT_SRC = RECAPCHA_SCRIPT;
const SITE_KEY = RECAPCHA_SITE_KEY;

export default function CaptchaBox({ visible, onToken }) {
	const containerRef = useRef(null);
	const widgetIdRef = useRef(null);
	const [scriptLoaded, setScriptLoaded] = useState(typeof window !== 'undefined' && !!window.grecaptcha);

	// Load script once
	useLayoutEffect(() => {
		if (!visible) return;

		if (window.grecaptcha) {
			setScriptLoaded(true);
			return;
		}

		const existing = document.querySelector('script[data-recaptcha-script]');
		if (existing) {
			existing.addEventListener('load', () => setScriptLoaded(true), { once: true });
			return;
		}

		const script = document.createElement('script');
		script.src = SCRIPT_SRC;
		script.async = true;
		script.defer = true;
		script.dataset.recaptchaScript = 'true';
		script.onload = () => setScriptLoaded(true);
		document.head.appendChild(script);
	}, [visible, scriptLoaded]);

	// Render widget
	useEffect(() => {
		if (!visible) return;
		if (!scriptLoaded) return;
		if (!containerRef.current) return;
		if (!window.grecaptcha) return;

		if (widgetIdRef.current !== null) return;

		const greRoot = window.grecaptcha;
		const gre = greRoot.enterprise || greRoot;

		if (!gre || typeof gre.render !== 'function') {
			console.error('reCAPTCHA render not available yet');
			return;
		}

		greRoot.ready(() => {
			if (widgetIdRef.current !== null) return;

			try {
				const id = gre.render(containerRef.current, {
					sitekey: SITE_KEY,
					badge: 'att',
					size: 'att', // Enterprise attestation checkbox
					tabindex: 0,
					action: 'loginsubmitdo',
					callback: token => {
						onToken?.(token);
					},
					'expired-callback': () => onToken?.(''),
					'error-callback': () => onToken?.(''),
					isolated: false
				});

				widgetIdRef.current = id;
			} catch (err) {
				console.error('reCAPTCHA render error:', err);
			}
		});
	}, [visible, scriptLoaded, onToken]);

	if (!visible) return null;

	return (
		<div className="flex justify-center mt-4">
      <div className="capchaBox__wrapper">
        <div className="capchaBox__recaptcha capchaBox__recaptcha-scale">
          <div ref={containerRef} id="recaptcha"></div>
        </div>
      </div>
		</div>
	);
}
